// import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  // LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  ListItemIcon,
  Typography
  // linearProgressClasses
} from '@mui/material';
import { gridSpacing } from 'store/constant';
import User1 from 'assets/images/users/user-round.svg';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { calculateQuota, showError } from 'utils/common';
import { API } from 'utils/api';

// assets
// import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';

// styles
// const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
//   height: 10,
//   borderRadius: 30,
//   [`&.${linearProgressClasses.colorPrimary}`]: {
//     backgroundColor: '#fff'
//   },
//   [`& .${linearProgressClasses.bar}`]: {
//     borderRadius: 5,
//     backgroundColor: theme.palette.primary.main
//   }
// }));

const CardStyle = styled(Card)(({ theme }) => ({
  // background: theme.typography.menuChip.background,
  background: '#4f46e5',
  margin: '0 18px',
  overflow: 'hidden',
  position: 'relative',
  // '&:after': {
  //   content: '""',
  //   position: 'absolute',
  //   width: '157px',
  //   height: '157px',
  //   background: theme.palette.primary[200],
  //   borderRadius: '50%',
  //   top: '-105px',
  //   right: '-96px'
  // }
}));

// ==============================|| PROGRESS BAR WITH LABEL ||============================== //

// function LinearProgressWithLabel({ value, ...others }) {
//   const theme = useTheme();

//   return (
//     <Grid container direction="column" spacing={1} sx={{ mt: 1.5 }}>
//       <Grid item>
//         <Grid container justifyContent="space-between">
//           <Grid item>
//             <Typography variant="h6" sx={{ color: theme.palette.primary[800] }}>
//               Progress
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Typography variant="h6" color="inherit">{`${Math.round(value)}%`}</Typography>
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid item>
//         <BorderLinearProgress variant="determinate" value={value} {...others} />
//       </Grid>
//     </Grid>
//   );
// }

// LinearProgressWithLabel.propTypes = {
//   value: PropTypes.number
// };

// ==============================|| SIDEBAR MENU Card ||============================== //

const MenuCard = () => {const { t } = useTranslation();
  
  const theme = useTheme();
    const account = useSelector((state) => state.account);
  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const { pathname } = useLocation();

  const loadUser = async () => {
    let res = await API.get(`/api/user/self`);
    const { success, message, data } = res.data;
    if (success) {
      setUsers(data);
    } else {
      showError(message);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  return (
    <CardStyle sx={{mt: 6, mr: 4}}>
      <CardContent sx={{ p: 2 }}>
        <List sx={{ p: 0, m: 0 }}>
          <ListItem alignItems="flex-start" disableGutters sx={{ p: 0 }}>
            {/* <ListItemAvatar sx={{ mt: 0 }}>
              <Avatar
                variant="rounded"
                src={User1}
                sx={{
                  ...theme.typography.commonAvatar,
                  ...theme.typography.largeAvatar,
                  color: theme.palette.primary.main,
                  border: 'none',
                  borderColor: theme.palette.primary.main,
                  background: '#fff',
                  marginRight: '12px'
                }}
                onClick={() => navigate('/panel/profile')}
              ></Avatar>
            </ListItemAvatar> */}
            <ListItemText
              sx={{ mt: 0 }}
              primary={
                <Typography variant="subtitle1" sx={{ color: '#fff', opacity: 0.8, fontSize: '12px' }}>
                  {t('menuCard.balance')}
                </Typography>
              }
            />
            {/* <ListItemButton sx={{ borderRadius: `${customization.borderRadius}px` }} onClick={() => navigate('/panel/profile')}>
              <ListItemText primary={<Typography variant="body2">立即充值</Typography>} />
            </ListItemButton> */}
          </ListItem>
        </List>
        <Grid item lg={12} xs={12}>
          <Grid item xs={12} sx={{ paddingBottom: '10px' }}>
            <Typography variant="h2" sx={{ color: '#fff'}}> {users?.quota !== undefined ? '¥' + calculateQuota(users.quota) : t('menuCard.unknown')}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button component={Link} variant="text" to="/panel/topup" sx={{ color: '#fff', background:'rgba(255, 255, 255, 0.2)', borderRadius: '8px', fontSize: '12px', width: '100%'}}>
              {t('menuCard.topUp')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </CardStyle>
  );
};

export default MenuCard;
